import { useState } from "react";
import { Plus } from "lucide-react";
import { mapFaqs } from "@/data/resort";
import { cn } from "@/lib/utils";
import { Eyebrow, Reveal } from "../reveal";

export function MapFAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section aria-labelledby="map-faq-heading" className="bg-background py-14 md:py-18">
      <div className="shell max-w-3xl">
        <Reveal>
          <Eyebrow>Good to Know</Eyebrow>
        </Reveal>
        <h2 id="map-faq-heading" className="display-lg mt-6">
          Questions About the Resort Map?
        </h2>

        <div className="mt-8 divide-y divide-border border-y border-border">
          {mapFaqs.map((faq, i) => {
            const isOpen = open === i;
            return (
              <div key={faq.q}>
                <h3>
                  <button
                    type="button"
                    className="flex w-full items-center justify-between gap-6 py-6 text-left"
                    aria-expanded={isOpen}
                    onClick={() => setOpen(isOpen ? null : i)}
                  >
                    <span className="font-display text-xl tracking-tight md:text-2xl">{faq.q}</span>
                    <Plus
                      className={cn(
                        "size-5 shrink-0 transition-transform duration-300",
                        isOpen && "rotate-45",
                      )}
                      strokeWidth={1.5}
                    />
                  </button>
                </h3>
                {isOpen ? (
                  <p className="pb-6 text-sm leading-relaxed text-muted-foreground md:text-base">
                    {faq.a}
                  </p>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
